module.exports = __webpack_public_path__ + "img/sky-arrow.5a5331ad.png";